/**
 * the 14 allergens that have to be declared for every food product in the EU
 * (Regulation (EU) No 1169/2011, Annex II)
 *
 * the letters are the abbreviations printed on menus all over the EU (A–R, the
 * letters I, J, K and Q are deliberately left out because they are easy to mix up
 * with each other or with digits)
 *
 * a product stores the ids of the allergens it contains in `Product.allergens` and
 * an optional free text remark in `Product.allergenNote`.
 * the names are ui translations (`allergen-<id>-name`, see allergenTranslationKey())
 * and live in the translation file of every app that displays them — only the ids
 * and letters are data and therefore shared from here.
 */
export const ALLERGENS = [
    { id: 'gluten', letter: 'A' },
    { id: 'crustaceans', letter: 'B' },
    { id: 'eggs', letter: 'C' },
    { id: 'fish', letter: 'D' },
    { id: 'peanuts', letter: 'E' },
    { id: 'soy', letter: 'F' },
    { id: 'milk', letter: 'G' },
    { id: 'nuts', letter: 'H' },
    { id: 'celery', letter: 'L' },
    { id: 'mustard', letter: 'M' },
    { id: 'sesame', letter: 'N' },
    { id: 'sulphites', letter: 'O' },
    { id: 'lupin', letter: 'P' },
    { id: 'molluscs', letter: 'R' },
];
export const ALLERGEN_IDS = ALLERGENS.map((allergen) => allergen.id);
/**
 * the translation key holding the (translated) name of an allergen
 */
export function allergenTranslationKey(allergenId) {
    return 'allergen-' + allergenId + '-name';
}
/**
 * the translation key holding the (translated) explanation of an allergen: which
 * ingredients it covers and where it typically hides
 */
export function allergenInfoTranslationKey(allergenId) {
    return 'allergen-' + allergenId + '-info';
}
export function allergenById(allergenId) {
    if (!allergenId) {
        return null;
    }
    for (let allergen of ALLERGENS) {
        if (allergen.id == allergenId) {
            return allergen;
        }
    }
    return null;
}
/**
 * the allergens a product contains, always in the order of ALLERGENS (so the
 * letters read alphabetically no matter in which order they were checked) with
 * unknown ids dropped
 */
export function allergensByIds(allergenIds) {
    if (!allergenIds || !Array.isArray(allergenIds) || allergenIds.length < 1) {
        return [];
    }
    return ALLERGENS.filter((allergen) => allergenIds.includes(allergen.id));
}
/**
 * the letters of the given allergens, ready to be displayed next to a product
 */
export function allergenLetters(allergenIds) {
    return allergensByIds(allergenIds).map((allergen) => allergen.letter);
}
/**
 * a clean list of allergen ids: only known ids, no duplicates, in the order of
 * ALLERGENS. use it before storing what a client sent.
 */
export function sanitizeAllergenIds(allergenIds) {
    return allergensByIds(allergenIds).map((allergen) => allergen.id);
}
